module.exports = __webpack_public_path__ + "static/media/22ESCWA24.1fa0d3db.jpg";